// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_35-3";
export var dialog = "_35-0";
export var divClassnameSwatch = "_35-8";
export var flexSwatch = "_35-4";
export var header = "_35-1";
export var styleAttributeSwatch = "_35-7";
export var swatch = "_35-2";
export var textHeaderSwatch = "_35-5";
export var webSwatch = "_35-6";